import React, { useState,useEffect } from "react";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ProfileCard from "../../Component/ProfileCard";
import { Container,Box } from "@mui/material";
import DriveWithUsState from "../../Hooks/DriveWithUs.state";
import Header from "Layout/Header";
import NotificationCard from "Component/NotificationCard";
const theme = createTheme();


export default function Notifications() {
  const [text, setText] = useState("");
  const {GetDriveWithUs,loading,driveWithUsData} = DriveWithUsState()
    const user = JSON.parse(localStorage.getItem("user"))

    useEffect(()=>{
      GetDriveWithUs(user?.token)
    },[])

  const mainUser = {
    
    title: "CEO of Apple",
    dt1: 32,
    dt2: 40,
    dt3: 50,
    firstName: { text },
    lastName: "Doe",
    midName: "Baker",
    gender: "female",
    phone: "932-555-4247",
    email: "janedoe@gmail.com",
    pass: "password123"
  };


  return (
    <ThemeProvider theme={theme}>
        <div className="cover-image" >
            <Header />
              <Container sx={{pt:{xs:1, md:4}}} >
           
            <Box sx={{textAlign:"start"}} >
              <h1  className="welcome-title" >Welcome {user?.first_name} {user?.last_name}</h1>
            </Box>
            </Container>
            </div>
      <CssBaseline>
      
        {/* BACKGROUND */}
        <Grid container direction="column" >
          <Grid item xs={12} md={6}>
           
            {/* <img
              alt="avatar"
              className="cover-image"
              style={{
                width: "100vw",
                height: "40vh",
                objectFit: "cover",
                objectPosition: "50% 50%",
                // position: "relative"
              }}
              src="/driver_forms/assets/images/main-image.jpg"
            /> */}
          </Grid>

          {/* COMPONENTS */}
          <Grid
            container
            direction={{ xs: "column", md: "row" }}
            spacing={3}
            sx={{
              position: {xs:"relative", md:"absolute"},
              top: {xs:"0vh", md:"35vh"},
              px: { xs: 0, md: 7 },
              zIndex:1
            }}
          >
            {/* PROFILE CARD */}
            <Grid item md={4}>
              <ProfileCard
               
              ></ProfileCard>
            </Grid>

            {/* SETTINGS CARD */}
            <Grid item md={8}>
              <NotificationCard
               
              ></NotificationCard>
            </Grid>
          </Grid>
        </Grid>
      </CssBaseline>
    </ThemeProvider>
  );
}
